// @flow
import React from 'react';
import { Row, Col, Card, Tab, Nav } from 'react-bootstrap';

// components
import PageTitle from '../../components/PageTitle';
import '../dashboard/Dashboard/Dashboard.css';
import UserBox from './UserBox';
import Settings from './Settings';
import { t } from 'i18next';

const index = () => {
    return (
        <>
            {/* <div className="row py-3">
                <div className="col-sm-6 ">
                    <div className="report">REPORT ALERT</div>
                </div>
                <div className="col-sm-6 d-flex justify-content-end">
                    <button className="export" type="button">
                        Export <i className="fas fa-file-export"></i>
                    </button>

                    <button className="update" id="update">
                        Update <i className="fas fa-sync-alt"></i>
                    </button>
                </div>
            </div> */}
            <Row>
                <Col>
                    <div className="page-title-box py-2">
                        <h4 className="point-title ps-5 fw-bold">{'My Account'}</h4>
                    </div>
                </Col>
            </Row>
            <div className=" profile-card mx-auto ">

                
                
                <Col xl={4} lg={5}>

                     
                    {/* User information */}
                    <UserBox />
                </Col>
                <div className='col-lg-8 '>
                   
                                <Settings />
                            
                      
                    
                </div>
            </div>
        </>
    );
};

export default index;
